export default "__VITE_ASSET__BzkhWfkH__"